<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#F3F3F3" opacity="1.000000" stroke="none" 
	d="
M1.000000,250.000000 
	C1.000000,170.978577 1.000000,91.957138 1.280818,12.759370 
	C4.702340,9.405360 7.875859,6.258590 10.938010,3.006941 
	C11.281610,2.642077 10.994583,1.683338 11.000000,1.000000 
	C135.688095,1.000000 260.376190,1.000000 385.236328,1.312107 
	C391.339111,5.580448 397.271393,9.529797 399.551636,16.890724 
	C399.604187,17.060423 400.498383,16.969408 401.000000,17.000000 
	C401.000000,94.354767 401.000000,171.709534 400.694397,249.237045 
	C396.868347,253.789383 393.395782,258.208862 389.798553,262.524445 
	C388.709656,263.830750 387.275818,264.849518 386.000000,266.000000 
	C262.978577,266.000000 139.957138,266.000000 16.761936,265.700378 
	C10.422634,261.635010 4.817532,257.360291 2.449453,250.071518 
	C2.396319,249.907974 1.501956,250.017731 1.000000,250.000000 
M102.862534,167.765747 
	C94.149750,166.681732 85.436958,165.597733 76.569031,164.494415 
	C76.569031,187.143646 76.569031,209.882080 76.569031,232.822845 
	C93.346893,232.822845 109.807610,232.921402 126.264648,232.719604 
	C128.815460,232.688324 131.495636,231.589737 133.866882,230.461273 
	C147.019913,224.201752 152.957001,213.324860 152.978943,199.119385 
	C153.060501,146.293854 153.017197,93.468109 153.006104,40.642452 
	C153.005798,39.186607 152.839371,37.730801 152.714508,35.687233 
	C150.669998,35.687233 148.889923,35.687214 147.109848,35.687233 
	C134.778305,35.687374 122.420494,36.199757 110.121323,35.568855 
	C91.183174,34.597397 76.439842,49.448776 76.308182,68.513199 
	C76.128647,94.508179 76.207649,120.505569 76.366783,146.500748 
	C76.376251,148.047394 77.782722,150.591431 79.040993,150.960526 
	C86.954483,153.281891 94.918991,156.133698 103.041512,156.863342 
	C113.647263,157.816055 119.789772,151.107925 119.903526,140.413605 
	C120.004555,130.916031 119.929901,121.416588 119.932365,111.917969 
	C119.933121,108.986282 119.932487,106.054596 119.932487,103.250542 
	C129.197113,103.250542 137.737488,103.250542 146.396561,103.250542 
	C146.396561,116.689659 146.688614,129.687271 146.309677,142.665298 
	C145.970016,154.298248 140.267792,162.017578 128.952240,164.803894 
	C120.814163,166.807800 112.197197,166.866882 102.862534,167.765747 
M239.999710,69.500000 
	C239.999710,58.380322 239.999710,47.260639 239.999710,36.013634 
	C222.825394,36.013634 206.162140,35.294437 189.595261,36.248520 
	C177.067795,36.969975 165.224228,48.709431 164.319351,61.652195 
	C163.189697,77.809967 164.047974,94.106720 164.047974,110.182930 
	C168.140488,108.231300 172.266998,105.602081 176.776062,104.230515 
	C194.006912,98.989265 211.349930,100.375343 228.607529,104.354744 
	C229.636124,104.591942 231.107864,105.882103 231.178894,106.777107 
	C231.471008,110.456886 231.301086,114.173332 231.301086,117.058533 
	C222.398071,115.101570 214.266235,112.544403 205.956131,111.657547 
	C191.406036,110.104774 181.452072,119.123550 181.006638,133.135178 
	C180.531250,148.089996 189.094070,157.482559 204.062668,156.893295 
	C211.383514,156.605103 218.625305,154.057205 225.875397,152.410980 
	C227.543152,152.032288 229.097977,151.156296 231.359451,150.245483 
	C231.359451,153.099167 231.081177,155.127991 231.412277,157.051971 
	C232.358414,162.550156 229.989212,164.392380 224.657059,165.335388 
	C203.630646,169.053925 183.033356,170.258743 163.656952,158.079651 
	C163.656952,183.238693 163.656952,207.956055 163.656952,233.074860 
	C176.307022,233.074860 188.617264,233.116302 200.926987,233.053040 
	C205.416199,233.029968 210.012375,233.326508 214.373138,232.496689 
	C229.790039,229.562927 239.956146,216.347000 239.978851,199.498978 
	C240.036789,156.499390 239.999130,113.499672 239.999710,69.500000 
M324.409454,162.500107 
	C324.409454,120.414421 324.409454,78.328728 324.409454,35.965977 
	C322.154541,35.858341 320.528931,35.715740 318.903168,35.713444 
	C306.075531,35.695332 293.247772,35.673393 280.420258,35.711704 
	C261.908539,35.766998 248.318497,49.141899 248.003448,67.775917 
	C247.826050,78.268349 247.943832,88.766022 247.970108,99.261238 
	C247.972839,100.352287 248.258179,101.442635 248.450623,102.803719 
	C262.719116,102.803719 276.694122,102.674385 290.664062,102.883926 
	C294.761230,102.945374 299.036407,103.394531 302.888519,104.685242 
	C308.782867,106.660225 311.923828,111.252380 312.103241,117.618637 
	C312.280518,123.909126 309.483429,128.466705 303.979919,131.419296 
	C302.805634,132.049301 301.618561,132.655518 300.092651,133.452835 
	C303.021942,134.547653 305.475861,135.181824 307.659790,136.329697 
	C317.487946,141.495422 319.101196,154.764755 310.155334,161.211319 
	C306.371033,163.938370 301.058502,165.420135 296.317871,165.760941 
	C286.704681,166.452026 277.007843,165.981644 267.345490,165.986694 
	C261.061096,165.989990 254.776703,165.987335 248.267151,165.987335 
	C248.267151,188.564606 248.267151,210.605011 248.267151,233.071869 
	C262.540619,233.071869 276.499634,233.079590 290.458679,233.070053 
	C311.083496,233.055954 324.149933,220.180557 324.376038,199.483887 
	C324.507080,187.490616 324.406342,175.494797 324.409454,162.500107 
M278.242188,155.831116 
	C280.045959,155.666260 281.922699,155.763306 283.639221,155.285172 
	C287.979523,154.076218 289.644012,150.722672 289.476898,146.554077 
	C289.306488,142.302017 287.110077,138.904495 282.732025,138.576889 
	C276.359497,138.100052 269.924744,138.454483 263.491760,138.454483 
	C263.491760,144.496445 263.491760,150.005676 263.491760,155.831238 
	C268.384003,155.831238 272.843811,155.831238 278.242188,155.831116 
M285.947205,125.408470 
	C288.690857,118.977493 286.956238,113.486679 281.289581,112.822983 
	C275.432800,112.137047 269.433228,112.670464 263.439270,112.670464 
	C263.439270,118.107903 263.439270,123.148849 263.439270,128.631821 
	C268.288605,128.631821 272.787384,128.945282 277.214722,128.518219 
	C280.021240,128.247498 282.721405,126.874222 285.947205,125.408470 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,16.528803 
	C400.498383,16.969408 399.604187,17.060423 399.551636,16.890724 
	C397.271393,9.529797 391.339111,5.580448 385.704163,1.312107 
	C390.927490,1.000000 395.854950,1.000000 401.000000,1.000000 
	C401.000000,6.017815 401.000000,11.037709 401.000000,16.528803 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M386.472656,266.000000 
	C387.275818,264.849518 388.709656,263.830750 389.798553,262.524445 
	C393.395782,258.208862 396.868347,253.789383 400.694397,249.704895 
	C401.000000,255.255463 401.000000,260.510925 401.000000,266.000000 
	C396.317657,266.000000 391.631470,266.000000 386.472656,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M1.000000,250.471191 
	C1.501956,250.017731 2.396319,249.907974 2.449453,250.071518 
	C4.817532,257.360291 10.422634,261.635010 16.294083,265.700378 
	C11.072522,266.000000 6.145044,266.000000 1.000000,266.000000 
	C1.000000,260.982178 1.000000,255.962280 1.000000,250.471191 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M10.513435,1.000000 
	C10.994583,1.683338 11.281610,2.642077 10.938010,3.006941 
	C7.875859,6.258590 4.702340,9.405360 1.280818,12.291516 
	C1.000000,8.417958 1.000000,4.835916 1.000000,1.000000 
	C4.006354,1.000000 7.016613,1.000000 10.513435,1.000000 
z"/>
<path fill="#285998" opacity="1.000000" stroke="none" 
	d="
M103.328186,167.779633 
	C112.197197,166.866882 120.814163,166.807800 128.952240,164.803894 
	C140.267792,162.017578 145.970016,154.298248 146.309677,142.665298 
	C146.688614,129.687271 146.396561,116.689659 146.396561,103.250542 
	C137.737488,103.250542 129.197113,103.250542 119.932487,103.250542 
	C119.932487,106.054596 119.933121,108.986282 119.932365,111.917969 
	C119.929901,121.416588 120.004555,130.916031 119.903526,140.413605 
	C119.789772,151.107925 113.647263,157.816055 103.041512,156.863342 
	C94.918991,156.133698 86.954483,153.281891 79.040993,150.960526 
	C77.782722,150.591431 76.376251,148.047394 76.366783,146.500748 
	C76.207649,120.505569 76.128647,94.508179 76.308182,68.513199 
	C76.439842,49.448776 91.183174,34.597397 110.121323,35.568855 
	C122.420494,36.199757 134.778305,35.687374 147.109848,35.687233 
	C148.889923,35.687214 150.669998,35.687233 152.714508,35.687233 
	C152.839371,37.730801 153.005798,39.186607 153.006104,40.642452 
	C153.017197,93.468109 153.060501,146.293854 152.978943,199.119385 
	C152.957001,213.324860 147.019913,224.201752 133.866882,230.461273 
	C131.495636,231.589737 128.815460,232.688324 126.264648,232.719604 
	C109.807610,232.921402 93.346893,232.822845 76.569031,232.822845 
	C76.569031,209.882080 76.569031,187.143646 76.569031,164.494415 
	C85.436958,165.597733 94.149750,166.681732 103.328186,167.779633 
z"/>
<path fill="#CA483A" opacity="1.000000" stroke="none" 
	d="
M239.999710,70.000000 
	C239.999130,113.499672 240.036789,156.499390 239.978851,199.498978 
	C239.956146,216.347000 229.790039,229.562927 214.373138,232.496689 
	C210.012375,233.326508 205.416199,233.029968 200.926987,233.053040 
	C188.617264,233.116302 176.307022,233.074860 163.656952,233.074860 
	C163.656952,207.956055 163.656952,183.238693 163.656952,158.079651 
	C183.033356,170.258743 203.630646,169.053925 224.657059,165.335388 
	C229.989212,164.392380 232.358414,162.550156 231.412277,157.051971 
	C231.081177,155.127991 231.359451,153.099167 231.359451,150.245483 
	C229.097977,151.156296 227.543152,152.032288 225.875397,152.410980 
	C218.625305,154.057205 211.383514,156.605103 204.062668,156.893295 
	C189.094070,157.482559 180.531250,148.089996 181.006638,133.135178 
	C181.452072,119.123550 191.406036,110.104774 205.956131,111.657547 
	C214.266235,112.544403 222.398071,115.101570 231.301086,117.058533 
	C231.301086,114.173332 231.471008,110.456886 231.178894,106.777107 
	C231.107864,105.882103 229.636124,104.591942 228.607529,104.354744 
	C211.349930,100.375343 194.006912,98.989265 176.776062,104.230515 
	C172.266998,105.602081 168.140488,108.231300 164.047974,110.182930 
	C164.047974,94.106720 163.189697,77.809967 164.319351,61.652195 
	C165.224228,48.709431 177.067795,36.969975 189.595261,36.248520 
	C206.162140,35.294437 222.825394,36.013634 239.999710,36.013634 
	C239.999710,47.260639 239.999710,58.380322 239.999710,70.000000 
z"/>
<path fill="#489952" opacity="1.000000" stroke="none" 
	d="
M324.409668,163.000122 
	C324.406342,175.494797 324.507080,187.490616 324.376038,199.483887 
	C324.149933,220.180557 311.083496,233.055954 290.458679,233.070053 
	C276.499634,233.079590 262.540619,233.071869 248.267151,233.071869 
	C248.267151,210.605011 248.267151,188.564606 248.267151,165.987335 
	C254.776703,165.987335 261.061096,165.989990 267.345490,165.986694 
	C277.007843,165.981644 286.704681,166.452026 296.317871,165.760941 
	C301.058502,165.420135 306.371033,163.938370 310.155334,161.211319 
	C319.101196,154.764755 317.487946,141.495422 307.659790,136.329697 
	C305.475861,135.181824 303.021942,134.547653 300.092651,133.452835 
	C301.618561,132.655518 302.805634,132.049301 303.979919,131.419296 
	C309.483429,128.466705 312.280518,123.909126 312.103241,117.618637 
	C311.923828,111.252380 308.782867,106.660225 302.888519,104.685242 
	C299.036407,103.394531 294.761230,102.945374 290.664062,102.883926 
	C276.694122,102.674385 262.719116,102.803719 248.450623,102.803719 
	C248.258179,101.442635 247.972839,100.352287 247.970108,99.261238 
	C247.943832,88.766022 247.826050,78.268349 248.003448,67.775917 
	C248.318497,49.141899 261.908539,35.766998 280.420258,35.711704 
	C293.247772,35.673393 306.075531,35.695332 318.903168,35.713444 
	C320.528931,35.715740 322.154541,35.858341 324.409454,35.965977 
	C324.409454,78.328728 324.409454,120.414421 324.409668,163.000122 
z"/>
<path fill="#4F9D59" opacity="1.000000" stroke="none" 
	d="
M277.772888,155.831177 
	C272.843811,155.831238 268.384003,155.831238 263.491760,155.831238 
	C263.491760,150.005676 263.491760,144.496445 263.491760,138.454483 
	C269.924744,138.454483 276.359497,138.100052 282.732025,138.576889 
	C287.110077,138.904495 289.306488,142.302017 289.476898,146.554077 
	C289.644012,150.722672 287.979523,154.076218 283.639221,155.285172 
	C281.922699,155.763306 280.045959,155.666260 277.772888,155.831177 
z"/>
<path fill="#519E5A" opacity="1.000000" stroke="none" 
	d="
M285.708252,125.701950 
	C282.721405,126.874222 280.021240,128.247498 277.214722,128.518219 
	C272.787384,128.945282 268.288605,128.631821 263.439270,128.631821 
	C263.439270,123.148849 263.439270,118.107903 263.439270,112.670464 
	C269.433228,112.670464 275.432800,112.137047 281.289581,112.822983 
	C286.956238,113.486679 288.690857,118.977493 285.708252,125.701950 
z"/>
</svg>